import { Badge, Box, Container, Group, Paper, Stack, Text, Timeline, Title, useMantineTheme } from '@mantine/core';

import {
  IconBed,
  IconBuildingChurch,
  IconCake,
  IconHeart,
  IconToolsKitchen2,
} from '@tabler/icons-react';

import { motion } from 'framer-motion';

import { PRIMARY_FONT } from '../../constants/fonts';

const TimelineSection = () => {
  const theme = useMantineTheme();
  const timelineEvents = [
    {
      time: '15:00',
      title: 'Ceremonia ślubna',
      //   description: 'Kościół pw. św. Stanisława Biskupa w Rydzynie',
      icon: IconBuildingChurch,
      useSecondaryColor: true,
    },
    {
      time: '16:00',
      title: 'Życzenia',
      //   description: 'Składanie życzeń Parze Młodej w Zamku Królewskim',
      icon: IconHeart,
      useSecondaryColor: true,
    },
    {
      time: '17:00',
      title: 'Obiad weselny',
      //   description: 'Rozpoczęcie wesela w Zamku Królewskim w Rydzynie',
      icon: IconToolsKitchen2,
      useSecondaryColor: true,
    },
    {
      time: '20:00',
      title: 'Tort na zewnątrz zamku',
      icon: IconCake,
      useSecondaryColor: true,
    },
    {
      time: '04:00',
      title: 'Planowany koniec imprezy',
      icon: IconBed,
      useSecondaryColor: true,
    },
  ];

  return (
    <Box
      id="timeline"
      py={100}
      style={{
        background: 'linear-gradient(180deg, #fafafa 0%, #ffffff 50%, #f8fafc 100%)',
        position: 'relative',
      }}
    >
      {/* Decorative background elements */}
      <Box
        style={{
          position: 'absolute',
          top: '20%',
          left: '5%',
          width: '180px',
          height: '180px',
          background: `radial-gradient(circle, rgba(${parseInt(theme.other.titleColor.slice(1, 3), 16)}, ${parseInt(theme.other.titleColor.slice(3, 5), 16)}, ${parseInt(theme.other.titleColor.slice(5, 7), 16)}, 0.08) 0%, transparent 70%)`,
          borderRadius: '50%',
          zIndex: 0,
        }}
      />
      <Box
        style={{
          position: 'absolute',
          bottom: '10%',
          right: '8%',
          width: '220px',
          height: '220px',
          background: `radial-gradient(circle, rgba(${parseInt(theme.other.titleColor.slice(1, 3), 16)}, ${parseInt(theme.other.titleColor.slice(3, 5), 16)}, ${parseInt(theme.other.titleColor.slice(5, 7), 16)}, 0.06) 0%, transparent 70%)`,
          borderRadius: '50%',
          zIndex: 0,
        }}
      />
      <Box
        style={{
          position: 'absolute',
          top: '60%',
          right: '15%',
          width: '150px',
          height: '150px',
          background: `radial-gradient(circle, rgba(${parseInt(theme.other.secondaryColor.slice(1, 3), 16)}, ${parseInt(theme.other.secondaryColor.slice(3, 5), 16)}, ${parseInt(theme.other.secondaryColor.slice(5, 7), 16)}, 0.08) 0%, transparent 70%)`,
          borderRadius: '50%',
          filter: 'blur(30px)',
          zIndex: 0,
        }}
      />

      <Container size="lg" style={{ position: 'relative', zIndex: 1 }}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] }}
          viewport={{ once: true }}
        >
          <Stack align="center" gap="lg" mb={60}>
            <Badge
              size="lg"
              variant="light"
              color={theme.other.titleColor}
              style={{
                fontSize: '0.9rem',
                padding: '8px 16px',
                fontWeight: 500,
              }}
            >
              Plan wydarzenia
            </Badge>

            <Title
              order={2}
              ta="center"
              style={{
                fontFamily: PRIMARY_FONT,
                fontSize: 'clamp(2.5rem, 6vw, 4rem)',
                fontWeight: 700,
                color: theme.other.titleColor,
                lineHeight: 1.2,
                marginBottom: '1rem',
              }}
            >
              Harmonogram dnia
            </Title>

            <Text
              size="lg"
              ta="center"
              c="dimmed"
              maw={600}
              style={{
                fontSize: '1.1rem',
                lineHeight: 1.6,
                fontFamily: PRIMARY_FONT,
              }}
            >
              Szczegółowy plan naszego wielkiego dnia
            </Text>
          </Stack>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <Paper
            shadow="xl"
            radius="xl"
            p="xl"
            style={{
              maxWidth: 700,
              margin: '0 auto',
              background: 'rgba(255, 255, 255, 0.8)',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255, 255, 255, 0.3)',
            }}
          >
            <Stack gap="lg">
              {timelineEvents.map((event, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                >
                  <Group gap="lg" align="center" wrap="nowrap">
                    {/* Time badge */}
                    <Badge
                      size="xl"
                      variant="filled"
                      style={{
                        minWidth: '80px',
                        fontSize: '1rem',
                        fontWeight: 600,
                        padding: '12px 16px',
                        fontFamily: PRIMARY_FONT,
                        backgroundColor: event.useSecondaryColor ? theme.other.secondaryColor : theme.other.titleColor,
                        color: event.useSecondaryColor ? 'black' : 'white',
                      }}
                    >
                      {event.time}
                    </Badge>

                    {/* Icon */}
                    <Box
                      style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '12px',
                        background: event.useSecondaryColor 
                          ? `rgba(${parseInt(theme.other.secondaryColor.slice(1, 3), 16)}, ${parseInt(theme.other.secondaryColor.slice(3, 5), 16)}, ${parseInt(theme.other.secondaryColor.slice(5, 7), 16)}, 0.2)`
                          : `rgba(${parseInt(theme.other.titleColor.slice(1, 3), 16)}, ${parseInt(theme.other.titleColor.slice(3, 5), 16)}, ${parseInt(theme.other.titleColor.slice(5, 7), 16)}, 0.1)`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: event.useSecondaryColor
                          ? `1px solid rgba(${parseInt(theme.other.secondaryColor.slice(1, 3), 16)}, ${parseInt(theme.other.secondaryColor.slice(3, 5), 16)}, ${parseInt(theme.other.secondaryColor.slice(5, 7), 16)}, 0.3)`
                          : `1px solid rgba(${parseInt(theme.other.titleColor.slice(1, 3), 16)}, ${parseInt(theme.other.titleColor.slice(3, 5), 16)}, ${parseInt(theme.other.titleColor.slice(5, 7), 16)}, 0.2)`,
                      }}
                    >
                      <event.icon size={24} color={event.useSecondaryColor ? 'black' : theme.other.titleColor} />
                    </Box>

                    {/* Event title */}
                    <Text
                      size="lg"
                      fw={600}
                      style={{
                        color: 'black',
                        fontFamily: PRIMARY_FONT,
                        letterSpacing: '-0.01em',
                        flex: 1,
                      }}
                    >
                      {event.title}
                    </Text>
                  </Group>
                </motion.div>
              ))}
            </Stack>
          </Paper>
        </motion.div>
      </Container>
    </Box>
  );
};

export { TimelineSection };
export default TimelineSection;
